<template>
  <div>
    <PageLoader
      v-if="loadingWarranties"
      message="Loading Warranty Programs..."
    />
    <div v-for="wp in warrantyPrograms" :key="wp.id">
      <WarrantyProgramCard :warranty-program="wp" class="mb-4" />
    </div>
    <div
      v-if="!warrantyPrograms.length && !loadingWarranties"
      class="no-results-message"
    >
      <i class="fad fa-question-circle"></i>
      No Warranties Available
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PageLoader from "@/components/PageLoader.vue";
import WarrantyProgramCard from "./WarrantyProgramCard.vue";

export default {
  components: {
    WarrantyProgramCard,
    PageLoader
  },
  props: {
    equipmentTypeIds: {
      type: Array,
      default: null
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingWarranties: true
    };
  },
  computed: {
    ...mapState({
      warrantyPrograms: function ({ warrantyPrograms }) {
        return warrantyPrograms.filter((wp) => {
          const conditions = [];
          if (this.active) conditions.push(wp.is_active);
          if (this.equipmentTypeIds) {
            conditions.push(
              !!wp.equipment_types.find(
                (equipmentType) =>
                  this.equipmentTypeIds.indexOf(equipmentType.id) > -1
              )
            );
          }
          return conditions.every((c) => c === true);
        });
      }
    })
  },
  mounted() {
    this.fetchWarrantyPrograms().finally(
      () => (this.loadingWarranties = false)
    );
  },
  methods: {
    ...mapActions(["fetchWarrantyPrograms"])
  }
};
</script>

<style lang="scss" scoped></style>
